import { createTagGQLMutation, getTagsGQLQuery, updateTagGQLMutation, } from '../../graphql/index.js';
export class TagsClient {
    constructor(client) {
        this.client = client;
    }
    async list(variables, fields, accessToken) {
        const result = await this.client.authorizedRequest({
            query: getTagsGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.tags;
    }
    async create(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: createTagGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.createTag;
    }
    async update(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: updateTagGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.updateTag;
    }
}
//# sourceMappingURL=tags.client.js.map